import ThemeToggle from "./ThemeToggle";

const Hero = () => {
  return (
    <section className="w-full py-16 md:py-24 lg:py-32 bg-gradient-to-b from-background via-muted/30 to-background relative overflow-hidden">
      {/* Subtle decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-40">
        <div className="absolute top-20 left-10 w-64 h-64 bg-primary/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-80 h-80 bg-secondary/20 rounded-full blur-3xl"></div>
      </div>
      
      <div className="absolute top-4 right-4 md:top-8 md:right-8 z-10">
        <ThemeToggle />
      </div>
      
      <div className="container mx-auto px-4 md:px-6 max-w-5xl text-center relative z-10">
        <div className="space-y-8 animate-fade-in">
          <div className="inline-block px-5 py-2 rounded-full bg-primary/10 border border-primary/20">
            <span className="text-sm font-medium text-primary">AI-Powered Username & Bio Generator</span>
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold tracking-tight text-foreground max-w-4xl mx-auto leading-tight">
            Create Perfect Usernames & Bios for Social Media
          </h1>
          
          <p className="text-lg md:text-xl lg:text-2xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Generate unique, creative usernames and engaging bios for Instagram, TikTok, YouTube, Twitter, and more. 
            Free, instant, and powered by advanced AI.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
            <a 
              href="#generator" 
              className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-primary-foreground rounded-lg font-semibold text-lg hover:bg-primary/90 transition-colors shadow-lg"
            >
              Start Generating Free
              <span className="text-xl">→</span>
            </a>
            <a 
              href="#how-it-works" 
              className="inline-flex items-center gap-2 px-8 py-4 bg-muted text-foreground rounded-lg font-semibold text-lg hover:bg-muted/80 transition-colors"
            >
              How It Works
            </a>
          </div>
          
          <div className="flex flex-wrap gap-3 justify-center text-sm pt-6 max-w-2xl mx-auto">
            <span className="px-4 py-2 rounded-full bg-card border border-border text-card-foreground">✓ No Sign-Up Required</span>
            <span className="px-4 py-2 rounded-full bg-card border border-border text-card-foreground">✓ 100% Free Forever</span>
            <span className="px-4 py-2 rounded-full bg-card border border-border text-card-foreground">✓ Instant Results</span>
            <span className="px-4 py-2 rounded-full bg-card border border-border text-card-foreground">✓ 12 Style Themes</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
